'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getWidgetTitleText = undefined;

var _getAnyCustomChatName = require('conversations-schema/chat-heading-config/operators/getAnyCustomChatName');

var _getRespondersNameText = require('./getRespondersNameText');

var getWidgetTitleText = exports.getWidgetTitleText = function getWidgetTitleText(chatHeadingConfig, responders) {
  var responderNames = (0, _getRespondersNameText.getRespondersNameText)(responders);
  return responderNames || (0, _getAnyCustomChatName.getAnyCustomChatName)(chatHeadingConfig);
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-internal-components/static-1.4266/js/visitor-widget/operators/getWidgetTitleText.js
// module id = 1052
// module chunks = 2 3